import React from 'react';
import Sidebar from './Sidebar';

/**
 * SidebarLayout — wraps any protected page with the fixed left sidebar.
 * Desktop (≥1024px): 280px fixed sidebar on the left, content fills the rest. NO top header.
 * Mobile (<1024px): MobileHeader (inside Sidebar) is fixed at top (60px), content offset below it.
 *
 * The MobileHeader inside Sidebar.jsx uses both lg:hidden AND .mobile-header-only CSS class
 * to ensure it NEVER renders on desktop (belt-and-suspenders approach).
 */
const SidebarLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#111111]">
      <Sidebar />
      {/*
        Desktop (≥1024px): pl-[280px] to offset sidebar, pt-0 (no top header exists on desktop).
        Mobile (<1024px):  pl-0, pt-[3.75rem] to offset the fixed MobileHeader (60px).
        The sidebar-main-content class + inline style ensure zero top offset on desktop.
      */}
      <main
        className="lg:pl-[280px] pt-[3.75rem] lg:pt-0 sidebar-main-content"
        style={{ minHeight: '100dvh' }}
      >
        {children}
      </main>
    </div>
  );
};

export default SidebarLayout;
